/* eslint-disable */
import React, { Suspense, useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes , useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import NewOrderNotification from '../src/views/orders-notification/orders-notification';

import { CSpinner, useColorModes } from '@coreui/react-pro'
import 'react-toastify/dist/ReactToastify.css'
import './scss/style.scss'

// We use those styles to show code examples, you should remove them in your application.
import './scss/examples.scss'
import ForgotPassword from './views/pages/forgotPassword/ForgotPassword'
import ResetPassword from './views/pages/forgotPassword/ResetPassword'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
// const NewOrderNotification = React.lazy(() => import('./views/orders-notification/orders-notification'));
// Email App
const EmailApp = React.lazy(() => import('./views/apps/email/EmailApp'))
import { storeLoginData, getLoginData, removeLoginData, isLoggedIn } from "./utils/loginSession";
import TawkChat from "./components/TalkChat";

const App = () => {
  const { isColorModeSet, setColorMode } = useColorModes(
    'coreui-pro-react-admin-template-theme-bright',
  )
  const storedTheme = useSelector((state) => state.theme)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.href.split('?')[1])
    const theme = urlParams.get('theme') && urlParams.get('theme').match(/^[A-Za-z0-9\s]+/)[0]
    if (theme) {
      setColorMode(theme)
    }
    setColorMode(storedTheme)
    if (isColorModeSet()) {
      return
    }

    setColorMode(storedTheme)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>

    <NewOrderNotification>
      
    </NewOrderNotification>
    <TawkChat/>
    <Router>
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      >
        <Routes>
          <Route exact path="/login" name="Login Page" element={<Login />} />
          <Route
            exact
            path="/forgot-password"
            name="Forgot Password Page"
            element={<ForgotPassword />}
          />
          <Route
            exact
            path="/reset-password"
            name="Reset Password Page"
            element={<ResetPassword />}
          />
          {/* <Route exact path="/register" name="Register Page" element={<Register />} /> */}
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route path="/apps/email/*" name="Email App" element={<EmailApp />} />
          <Route path="*" name="Home" element={<DefaultLayout />} />
          <Route path="/" element={<CheckUser />} />

          {/* <Route path="*" name="Home" element={<DefaultLayout />} /> */}
        </Routes>
      </Suspense>
      </Router>
      </div>
  )
}
const CheckUser = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = getLoginData(); 

    if (user) {
      navigate("/dashboard"); 
    } else {
      navigate("/login"); 
    }
  }, [navigate]);

  return null; 
};

export default App
